<form [formGroup]="settingsForm" class="form-validation" (ngSubmit)="settingsFormSubmit()">
  
  <div class="row">
    <div class="form-group col-sm-6">
      <label style="width: 100%;">{{editLang.language}}</label>
      
      <div class="checkbox_aligned">
        <img src="/assets/images/flag_02.png">
        <div class="checknew">
          <label class="checkbox checkbox-custom">
            <input type="radio" formControlName="lang_val" value="1"><i></i> Italian
          </label>
        </div>
      </div>

      <div class="checkbox_aligned">
        <img src="/assets/images/flag_01.png">
        <div class="checknew">
          <label class="checkbox checkbox-custom">
            <input type="radio" formControlName="lang_val" value="0"><i></i> English
          </label>
        </div>
      </div>
      
    </div>
  </div>

  <div class="row">
    <div class="form-group col-sm-6">
      <label>{{editLang.timezone}}</label>
      <select style="width: 40%;" class="form-control" formControlName="timezone">
        <option *ngFor="let timezones of timezoneConfig" [ngValue]="timezones.timezone">{{timezones.content}}</option>
      </select>
    </div>
  </div>

  <div class="row mt5">
    <div class="col-md-12 text-center">
      <button style="float: left;" type="button" class="btn btn-warning mb-10" (click)="settingsFormEditEnable()"
        *ngIf="!settingsFormEdit">{{editLang.edit}}</button>
      <button style="float: left;" type="submit" class="btn btn-success mb-10"
        *ngIf="settingsFormEdit">{{editLang.update}}</button>
    </div>
  </div>

</form>
